import { ServicesContainer } from "@/lib/services/container"
import { ServicesContext } from "@/lib/services/context"

export namespace Services {
  export type ContextData = {
    selectService: Functions.Select
    selected: Option
    selectedLabel: Label
  }

  export type Options = {
    acupuncture: `Acupuncture`
    chiropractic: `Chiropractic`
    hand_therapy: `Hand Therapy`
    massage: `Massage`
    osteopathy: `Osteopathy`
    physiotherapy: `Physiotherapy`
    podiatry: `Podiatry`
  }

  export type Collection<Element> = Record<Option, Element>

  export type Label = Options[keyof Options]

  export type Option = keyof Options

  export const Context = ServicesContext
  export const Container = ServicesContainer

  export namespace Functions {
    export type Select = (args: { service: Option }) => void
  }
}
